import { AnimalAvatar } from "@/components/animal-avatar";
import {
  EyeClosedIcon,
  EyeOpenIcon,
  StarFilledIcon,
  StarIcon,
} from "@radix-ui/react-icons";
import { Box, Flex, IconButton, Text } from "@radix-ui/themes";

interface TimelineGroupItemProps {
  content: number | string;
  color: string;
  isHidden: boolean;
  isSaved: boolean;
  onHide?: () => void;
  onSave?: () => void;
  canHide?: boolean;
  canSave?: boolean;
}

const TimelineGroupItem = ({
  content,
  color,
  isHidden = false,
  isSaved = false,
  onHide,
  onSave,
  canHide = false,
  canSave = false,
}: TimelineGroupItemProps) => {
  const starIcon = isSaved ? (
    <StarFilledIcon width={16} height={16} />
  ) : (
    <StarIcon width={16} height={16} />
  );

  const eyeIcon = isHidden ? (
    <EyeClosedIcon width={16} height={16} />
  ) : (
    <EyeOpenIcon width={16} height={16} />
  );

  return (
    <Flex align="center" justify="between">
      <Text size="1" weight="regular" color="gray" highContrast>
        {!Number.isNaN(Number(content)) ? (
          <Flex align="center" gap="1">
            <AnimalAvatar
              showTitle
              titleSize="1"
              size="18px"
              enableHoverZoom
              trackId={String(content)}
            />
          </Flex>
        ) : (
          content
        )}
      </Text>
      <Flex align="center" ml="6" className="group-item-action-buttons">
        {canHide ? (
          <IconButton
            variant="ghost"
            color="gray"
            size="1"
            mr="3"
            onClick={() => onHide?.()}
          >
            {eyeIcon}
          </IconButton>
        ) : null}
        {canSave ? (
          <IconButton
            variant="ghost"
            color="gray"
            size="1"
            mr="2"
            onClick={() => onSave?.()}
          >
            {starIcon}
          </IconButton>
        ) : null}
        <Box
          width="8px"
          height="24px"
          style={{
            backgroundColor: color,
            borderBottom: "1px solid #eee",
          }}
        ></Box>
      </Flex>
    </Flex>
  );
};

export default TimelineGroupItem;
